<template>
  <div v-if="visible" class="notice-overlay" @click="handleOverlayClick">
    <div class="notice-dialog" @click.stop>
      <div class="notice-close" @click="closeDialog">
        <i class="el-icon-close"></i>
      </div>
      <div class="notice-title">{{ title }}</div>
      <div class="notice-content">
        <div class="notice-text" v-html="renderedContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoticeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    isRichText: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    renderedContent() {
      if (!this.content) return '';
      if (this.isRichText) {
        return this.content;
      }
      return this.content.replace(/\n/g, '<br>');
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    handleOverlayClick() {
      this.closeDialog();
    }
  }
}
</script>

<style scoped>
.notice-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.notice-dialog {
  background: #ffffff;
  border-radius: 0.12rem;
  box-shadow: 0 0.04rem 0.24rem rgba(0, 0, 0, 0.12);
  max-width: 5rem;
  width: 90%;
  max-height: 75vh;
  position: relative;
  overflow: hidden;
}

.notice-close {
  position: absolute;
  top: 0.15rem;
  right: 0.15rem;
  width: 0.24rem;
  height: 0.24rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.notice-close i {
  font-size: 0.3rem;
  color: #999;
  transition: color 0.2s;
}

.notice-close:hover i {
  color: #333;
}

.notice-title {
  padding: 0.24rem 0.24rem 0.12rem 0.24rem;
  font-size: 0.2rem;
  font-weight: 600;
  color: #1a1a1a;
  text-align: left;
  padding-right: 0.5rem;
}

.notice-content {
  padding: 0 0.24rem 0.24rem 0.24rem;
  max-height: 55vh;
  overflow-y: auto;
}

.notice-text {
  font-size: 0.14rem;
  line-height: 1.7;
  color: #333;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* 富文本图片自适应 */
.notice-text >>> img {
  max-width: 100%;
  height: auto;
  border-radius: 0.04rem;
  margin: 0.08rem 0;
  display: block;
}

.notice-text >>> p {
  margin: 0 0 0.08rem 0;
}

.notice-text >>> h1,
.notice-text >>> h2,
.notice-text >>> h3,
.notice-text >>> h4,
.notice-text >>> h5,
.notice-text >>> h6 {
  margin: 0.12rem 0 0.06rem 0;
  font-weight: 600;
  color: #1a1a1a;
}

.notice-text >>> ul,
.notice-text >>> ol {
  padding-left: 0.2rem;
  margin: 0.06rem 0;
}

.notice-text >>> a {
  color: #1890ff;
  text-decoration: none;
}

.notice-text >>> blockquote {
  border-left: 0.03rem solid #ddd;
  padding-left: 0.12rem;
  margin: 0.08rem 0;
  color: #666;
}

@media (max-width: 768px) {
  .notice-dialog {
    width: 90%;
    max-width: none;
    border-radius: 0.16rem;
  }

  .notice-title {
    font-size: 0.32rem;
    padding: 0.3rem 0.5rem 0.16rem 0.3rem;
  }

  .notice-content {
    padding: 0 0.3rem 0.3rem 0.3rem;
  }

  .notice-text {
    font-size: 0.22rem;
  }

  .notice-close {
    top: 0.12rem;
    right: 0.12rem;
    width: 0.3rem;
    height: 0.3rem;
  }

  .notice-close i {
    font-size: 0.35rem;
  }
}

.notice-content::-webkit-scrollbar {
  width: 0.03rem;
}

.notice-content::-webkit-scrollbar-track {
  background: transparent;
}

.notice-content::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 0.02rem;
}

.notice-content::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}
</style>
